import React from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {getPreview, getTotalPreview, loadObjects} from "./../../actions/actions";
import {withStyles} from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Header from "./../Header";
import Footer from "./../Footer";
import SearchBar from "./../controls/SearchBar.jsx";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Map as LeafletMap, Marker, Popup, TileLayer} from 'react-leaflet'
import MarkerClusterGroup from './MarkerClusterGroup';
import { check } from './../../helpers/browser';

const styles = theme => ({
  root: {
    width: "100%",
    gridColumnStart: 2,
    gridColumnEnd: 4
  },
  showOnMap: {
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },

  resetPadding: {
    padding: 0
  },
  newColor: {
    borderRadius: 0,
    backgroundColor: "transparent",
    borderBottom: "1px solid #76b5b8",
    boxShadow: "none",
    "&::before": {
      height: 0
    }
  },
  color: {
    color: "#76b5b8"
  },
  title: {
    color: "#76b5b8",
    textOverflow: "ellipsis",
    maxWidth: "95%"
  },
  headerStatic: {
    margin: "20px 0",
    fontSize: 26,
    fontFamily: "PT Sans Narrow, sans-serif",
    fontWeight: "bold"
  },
  subHeader: {
    fontSize: 18,
    fontFamily: "PT Sans Narrow, sans-serif",
    fontWeight: "bold",
    margin: "0 0 15 0"
  },
  textStatic: {
    margin: "20px 0",
    maxWidth: "65%",
    color: "#5b5b5b"
  },
  blockDescription: {
    marginTop: "30px",
    marginBottom: "20px"
  },
  list: {
    margin: "30 0 65 0"
  },
  maps: {
    width: "100%",
    display: "block",
    margin: "20 0 30 0",
    "&:nth-child(1)": {
      marginRight: "auto",
      marginLeft: "auto"
    }
  }
});

const mapOptions = {
  state: {center: [53.901437, 27.570577], zoom: 7},
  width: "auto",
  height: 500
};

const objectManagerOptions = {
  options: {
    clusterize: true,
    gridSize: 100
  },
  objects: {
    openBalloonOnClick: true,
    preset: "islands#greenDotIcon"
  },
  clusters: {
    preset: "islands#redClusterIcons"
  },
  modules: [
    "objectManager.addon.objectsBalloon",
    "objectManager.addon.objectsHint"
  ]
};

const zoomControlOptions = {
  options: {
    size: "auto",
    zoomDuration: 1000
  }
};

const mapObjects = objects =>
    objects.map((coord, index) => ({
      type: "Feature",
      id: `feat-${index}`,
      geometry: {
        type: "Point",
        coordinates: [coord.object_address_lon, coord.object_address_lat]
      },
      properties: {
        balloonContentHeader: coord.object_name,
        balloonContent: `
            Наименование заказчика: ${coord.client_org_name}. \n 
            Инспекционный орган: ${coord.inspection_name}. \n
            `,
        balloonContentFooter: `Регистрационный номер: ${
            coord.registration_number
            }.`,
        comment: `| Дата регистрации: ${coord.registration_date}.`
      }
    }));

const ObjectsMap = ({objects = [], latLon}) => {
  const zoom = latLon !== null ? 16 : 6;
  const center = latLon !== null ? latLon : [53, 29];
  const markers = objects.map((coord) => {
    if (coord.object_address_lon && coord.object_address_lat) {
      let lon = parseFloat(coord.object_address_lon);
      let lat = parseFloat(coord.object_address_lat);
      let dateRegistration = null;
      if (coord.registration_date) {
        dateRegistration = <div>
          <span>Дата регистрации:</span>{typeof coord.registration_date.date != 'undefined' ? coord.registration_date.date.substr(0, 10) : 'не указана'}
        </div>;
      }
      if (lon && lat) {
        return (
            <Marker position={[lon, lat]}>
              <Popup className={'dzbn-object-marker'}>
                <div className={'dzbn-object-marker-title'}>{coord.object_name}</div>
                <div><span>Наименование заказчика:</span>{coord.client_org_name}</div>
                <div><span>Инспекционный орган:</span>{coord.inspection_name}</div>
                <div><span>Регистрационный номер:</span>{coord.registration_number}</div>
                {dateRegistration}
              </Popup>
            </Marker>
        )
      }
    }
  });
  return (
      <LeafletMap
          center={center}
          zoom={zoom}
          maxZoom={18}
          attributionControl={true}
          zoomControl={true}
          doubleClickZoom={true}
          scrollWheelZoom={true}
          dragging={true}
          animate={true}
          easeLinearity={0.35}>
        <TileLayer url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'/>
        <MarkerClusterGroup>
          {markers}
        </MarkerClusterGroup>
      </LeafletMap>
  )
};

const Loader = ({previewIsLoading}) =>
!!previewIsLoading && <LinearProgress/>;

const SearchResults = ({bo, classes, onSelected}) => {
  if (bo && bo.length) {
    return bo.map((item, i) => {
      let showonmap = null;
      if (item && item.object_address_lon && item.object_address_lon) {
        let lon = parseFloat(item.object_address_lon);
        let lat = parseFloat(item.object_address_lat);
        if (lon && lat) {
          showonmap = <div className={classes.showOnMap} onClick={() => onSelected(item)}>Показать на карте</div>;
        }
      }
      return (
          <ExpansionPanel key={`key-${i}`} classes={{root: classes.newColor}}>
            <ExpansionPanelSummary
                classes={{root: classes.resetPadding}}
                expandIcon={<ExpandMoreIcon className={classes.color}/>}
            >
              <Typography className={classes.title}>{item.object_name}</Typography>
            </ExpansionPanelSummary>
            {showonmap}
            <ExpansionPanelDetails>
              <Typography>
                <Typography className={classes.blockDescription}>
                  <b>Наименование заказчика</b>
                </Typography>
                <Typography>{item.client_org_name}</Typography>
                <Typography className={classes.blockDescription}>
                  <b>Инспекционный орган</b>
                </Typography>
                <Typography>{item.inspection_name}</Typography>
                <Typography className={classes.blockDescription}>
                  <b>Регистрационный номер</b>
                </Typography>
                <Typography>{item.registration_number}</Typography>
                <Typography className={classes.blockDescription}>
                  <b>Дата регистрации</b>
                </Typography>
                <Typography>{item.registration_date}г.</Typography>
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>);
    });
  }

  return <Paper>Искомых объектов не найдено</Paper>;
};

export class Objects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disable_content: false,
      preview_total: null,
      preview_total_loaded: false,
      preview: [],
      bo_search: "",
      bo: [],
      latLon: null
    };

    this.mapRef = React.createRef();
    this.index = 0;
    this.value = null;

    this.handleObjectSelected = this.handleObjectSelected.bind(this);
  }

  componentWillMount() {
    let bData = check();
    if (bData.browserName =='Microsoft Internet Explorer' && (bData.majorVersion < 11)) {
      this.setState({'disable_content': true});
    } else {
      this.props.getPreview([], this.state.bo_search);
    }
  }

  updateInput = value => {
    this.value = value;
    this.index++;
    setTimeout(() => this.updateObjects(), 1000);
  };

  updateObjects() {
    this.index--;
    if (this.index === 0) {
      this.props.getPreview([], this.value);
      this.setState({bo_search: this.value});
    }
  }

  handleObjectSelected(obj) {
    this.setState({latLon: [obj.object_address_lon, obj.object_address_lat]});
    window.scrollTo(0, this.mapRef.current.offsetTop);
  }

  handleSearch = e => {
    e.preventDefault();
    this.props.getPreview([], this.state.bo_search);
  };

  render() {
    let {classes, bo, preview = [], previewIsLoading} = this.props;
    return (
        <div>
          <Header/>
          <div className={classes.root}>
            <div style={{marginRight: "12%", marginLeft: "12%"}}>
              <Typography component="h2" className={classes.headerStatic} variant="headline">
                Поднадзорные объекты
              </Typography>
              {this.state.disable_content && (<Typography style={{height:'95%'}} className={classes.textStatic}>Версия вашего браузера устарела. Обновите браузер до актуальной версии.</Typography>)}
              {!this.state.disable_content && (<div>
              <Typography className={classes.textStatic}>
                В данный момент карта работает в тестовом режиме. Если вы не нашли
                интересующий вас объект, просим обратиться в соответствующую
                инспекцию. Используйте актуальные версии браузеров Internet Explorer, Edge, Chrome, Opera, Firefox, Safari.
              </Typography>
              <Loader previewIsLoading={previewIsLoading}/>
              <SearchBar placeholderInput="Введите данные объекта для его поиска" textBtn="Поиск"
                         onChange={this.updateInput}/>
              <div ref={this.mapRef} className={classes.maps}>
                <ObjectsMap objects={preview} latLon={this.state.latLon}/>
              </div>
              {this.state.bo_search !== "" && (
                  <Typography component="div" className={classes.list}>
                    <Typography component="h4" className={classes.subHeader} variant="headline">
                      Результаты поиска
                    </Typography>
                    <SearchResults bo={bo} classes={classes} onSelected={this.handleObjectSelected}/>
                  </Typography>
              )}
                </div>)}
            </div>
          </div>
          <Footer/>
        </div>
    );
  }
}

Objects.defaultProps = {
  bo: [],
  preview_total: null,
  preview_total_loaded: false,
  preview: [],
  total: 0,
  page: 1
};

function mapDispatch(dispatch) {
  return {
    loadObjects: bindActionCreators(loadObjects, dispatch),
    getTotalPreview: bindActionCreators(getTotalPreview, dispatch),
    getPreview: bindActionCreators(getPreview, dispatch)
  };
}

function select(state, props) {
  const {bo} = state;

  return {
    bo: bo.bo || [],
    preview_total: "preview_total" in bo ? bo.preview_total : 0,
    preview_total_loaded:
        "preview_total_loaded" in bo ? bo.preview_total_loaded : false,
    preview: "preview" in bo ? bo.preview : [],
    total: "total" in bo ? bo.total : 0,
    page: "page" in bo ? parseInt(bo.page) : 1,
    previewIsLoading: state.bo.preview_is_loading
  };
}

export const ObjectsWithStyles = withStyles(styles)(Objects);

export default connect(
    select,
    mapDispatch
)(ObjectsWithStyles);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/Objects.jsx